// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"10328":"7c824f1527b27b98","46252":"6d49a05bc7ea9785","52433":"2baf92507eebf954","55422":"0a8f745d5a70172a"}[chunkId] + ".css";
};